// @flow

import { logger } from 'shared/utils/logger';
import { sendToLogin } from 'shared/utils/helpers';

type ResponseCatcher = {
  or: (f: (res: Response) => mixed) => mixed
};

export const handleAuthFailure = (err: Response): ResponseCatcher => {
  if ([401, 403].includes(err.status)) {
    logger.log(`Received ${err.status} from server - redirecting to login`);
    sendToLogin();
    return { or: () => {} };
  } else {
    return {
      or: (f) => f(err)
    };
  }
};
